import { Component, OnInit } from '@angular/core';
import { UserGroupsService } from '../../core/services/usergroups.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UiService } from '../../core/services/ui.service';

@Component({
  selector: 'userGroups-edit',
  templateUrl: './usergroups-create-edit.template.html',
})
export class UserGroupsEditComponent implements OnInit {
  public userGroup;
  constructor(
    private userGroupsSrv: UserGroupsService,
    private route: ActivatedRoute,
    private router: Router,
    private ui: UiService
  ) {}
  ngOnInit() {
    this.ui.toolbar.title = 'Editar Grupo';
    var userGroupId = this.route.snapshot.params['id'];
    this.userGroupsSrv
      .find(userGroupId)
      .then((userGroup) => (this.userGroup = userGroup));
  }
  handleSubmit(evt) {
    evt.preventDefault();
    this.saveUserGroup();
  }
  saveUserGroup() {
    this.userGroupsSrv.save(this.userGroup).then((userGroup) => {
      this.ui.snackbar.show({
        message: 'Grupo actualizado!',
      });
      this.router.navigate(['/tasks/usergroups/' + userGroup.id]);
    });
  }
}
